export default 'https://tme.understood.org/assets/carrot.5232d711.lottie'